import React, { useMemo, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  ToggleButton,
  ToggleButtonGroup,
  Box,
  Paper,
} from '@mui/material';

export default function EmailCampaignPreviewDialog({ open, onClose, html = '' }) {
  const [device, setDevice] = useState('desktop');

  const srcDoc = useMemo(() => {
    const value = String(html || '').trim();
    if (!value) {
      return '<html><body style="font-family:Arial;padding:24px;">No content to preview.</body></html>';
    }
    return value;
  }, [html]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>Email Preview</DialogTitle>

      <DialogContent>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1.5 }}>
          <ToggleButtonGroup
            value={device}
            exclusive
            onChange={(_, value) => value && setDevice(value)}
            size="small"
          >
            <ToggleButton value="desktop">Desktop</ToggleButton>
            <ToggleButton value="mobile">Mobile</ToggleButton>
          </ToggleButtonGroup>
        </Box>

        <Paper
          variant="outlined"
          sx={{
            p: 1,
            width: device === 'mobile' ? 375 : '100%',
            maxWidth: '100%',
            mx: 'auto',
          }}
        >
          <iframe
            title="email-preview"
            srcDoc={srcDoc}
            style={{
              border: 0,
              width: '100%',
              minHeight: 520,
              background: '#fff',
            }}
          />
        </Paper>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
